import { defineMessages } from 'react-intl';

export const Divider = defineMessages({
  meterModelName: {
    id: 'app.Divider.meterModelName',
    defaultMessage: 'Meter model: {meterModelName}',
  },
  unknownMeterModel: {
    id: 'app.Divider.unknownMeterModel',
    defaultMessage: 'Model měřidla není vybrán',
  },
});
